import script from "./stock-ticker.vue?vue&type=script&lang=js"
export * from "./stock-ticker.vue?vue&type=script&lang=js"

import "./stock-ticker.vue?vue&type=style&index=0&id=10f8cf17&lang=scss"

const __exports__ = script;

export default __exports__